import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import * as moment from "moment";

import Widget from "./Widgets";
import SectionV2 from "./SectionV2";
import TopSellersV2 from "./TopSellersV2";
import BreadCrumb from "../../Components/Common/BreadCrumb";

const DashboardV2Page = () => {
  const { t, i18n } = useTranslation();
  const [widgets, setWidgets] = useState([]);
  const [data, setData] = useState();
  const [dateValue, setDateValue] = useState();
  const [isApplyingNewFilter, setIsApplyingNewFilter] = useState(true);

  document.title = `${t("Dashboard.Dashboard")} | ${t(
    process.env.REACT_APP_HEADING
  )}`;

  useEffect(() => {
    let currentDay = new Date();
    setDateValue([currentDay, currentDay]);
  }, []);

  useEffect(() => {
    setIsApplyingNewFilter(true);
    const sse = subscribeToStream(dateValue);
    function getRealtimeData(eventData) {
      setData(JSON.parse(eventData));
    }
    sse.onmessage = (e) => {
      setIsApplyingNewFilter(false);
      getRealtimeData(e.data);
    };
    sse.onerror = () => {
      sse.close();
    };
    return () => {
      sse.close();
    };
  }, [dateValue]);

  useEffect(() => prepareWidgets(), [data, i18n.language]);

  /**
   * subscribe to SSE
   * @returns
   */
  const subscribeToStream = () => {
    const sse_key = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser")).sse_key
      : null;
    let streamingEndpoint = `${process.env.REACT_APP_API_URL}/api/dashboard/sse?key=${sse_key}`;
    if (dateValue?.length === 1) {
      streamingEndpoint += `&from=${moment(new Date(dateValue[0])).format(
        "yyyy-MM-DD"
      )}&to=${moment(new Date(dateValue[0])).format("yyyy-MM-DD")}`;
    } else if (dateValue?.length === 2) {
      streamingEndpoint += `&from=${moment(new Date(dateValue[0])).format(
        "yyyy-MM-DD"
      )}&to=${moment(new Date(dateValue[1])).format("yyyy-MM-DD")}`;
    }
    return new EventSource(streamingEndpoint);
  };

  const prepareWidgets = () => {
    const results = [];
    results.push({
      id: 1,
      cardColor: "primary",
      label: t("Dashboard.All Users"),
      badge: "ri-arrow-right-up-line",
      badgeClass: "success",
      counter: data?.users,
      link: "null",
      linkCaption: "null",
      bgcolor: "success",
      icon: "bx bx-group",
    });
    results.push({
      id: 2,
      cardColor: "secondary",
      label: t("Dashboard.Customers"),
      badge: "ri-arrow-right-down-line",
      badgeClass: "danger",
      counter: data?.customers,
      link: "users/customers",
      linkCaption: t("Customers.View Customers"),
      bgcolor: "info",
      icon: "bx bx-user",
    });
    results.push({
      id: 3,
      cardColor: "success",
      label: t("Dashboard.Technicians"),
      badge: "ri-arrow-right-up-line",
      badgeClass: "success",
      counter: data?.technicians,
      link: "users/technicians",
      linkCaption: t("Technicians.View Technicians"),
      bgcolor: "warning",
      icon: "bx bx-wrench",
    });

    results.push({
      id: 5,
      cardColor: "info",
      label: t("Dashboard.Total Orders"),
      badgeClass: "muted",
      counter: data?.orders,
      link: "orders",
      linkCaption: t("Dashboard.View Orders"),
      icon: "bx bx-shopping-bag",
      bgcolor: "primary",
    });
    results.push({
      id: 6,
      cardColor: "info",
      label: t("Dashboard.Daily Average Orders"),
      badgeClass: "muted",
      counter: data?.avgDailyOrders,
      link: "null",
      linkCaption: "null",
      bgcolor: "primary",
      icon: "bx bx-stats",
      decimals: 2,
    });
    results.push({
      id: 7,
      cardColor: "info",
      icon: "bx bx-credit-card",
      label: t("Dashboard.Purchases"),
      badgeClass: "muted",
      counter: data?.purchases,
      link: "null",
      linkCaption: "null",
      bgcolor: "primary",
    });
    results.push({
      id: 8,
      cardColor: "info",
      icon: "bx bx-wallet-alt",
      label: t("Dashboard.Purchase Value"),
      badgeClass: "muted",
      counter: data?.value,
      link: "null",
      linkCaption: "null",
      bgcolor: "primary",
      decimals: 2,
    });
    setWidgets(results);
  };

  const onChangeDate = (dates) => {
    setDateValue(dates);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={t("Dashboard.Dashboard")}
            pageTitle={t("Dashboard.Dashboard")}
          />
          <Row>
            <Col>
              <div className="h-100">
                <SectionV2
                  value={dateValue}
                  onChange={(value) => onChangeDate(value)}
                  isApplyingNewFilter={isApplyingNewFilter}
                />
                <Row>
                  <Widget data={widgets} />
                </Row>
                <Row>
                  <TopSellersV2 data={data?.categories} />
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardV2Page;
